import { z } from "zod";

import { CoSignRequirementReasonArray } from "@/core/constants/(permissions)/cosign";

export const coSignFormSchema = z
  .object({
    requirementReason: z.union([z.enum(CoSignRequirementReasonArray), z.literal("")]),
    requirementReasonDetails: z.string().nullable(),
    supervisorId: z.uuid(),
  })
  .superRefine((data, ctx) => {
    if (!data.requirementReason) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["requirementReason"],
      });
    }
    if (data.requirementReason === "Other" && !data.requirementReasonDetails) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["requirementReasonDetails"],
      });
    }
  });

export type CoSignFormValues = z.infer<typeof coSignFormSchema>;
